module.exports = __webpack_public_path__ + "img/snap_02.da69f962.png";